import { IntegrationSystem } from '@/shared/types';
import { RMPServiceCode } from '@/shared/types/serviceCodes';

import { client } from '../../core/client';

import type { DictionaryFamilyRelationshipDegrees, GeneralDictionaryType, DataResponse } from '../../types';

export const rmp = {
  dictionary: {
    getFamilyRelationshipDegrees: (
      serviceCode: RMPServiceCode.MISSING_PERSON | RMPServiceCode.MISSING_PERSON_EXTRACT,
    ): Promise<DataResponse<DictionaryFamilyRelationshipDegrees[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getFamilyRelationshipDegrees/${serviceCode}`);
    },
    getMilitaryServiceTypes: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getMilitaryServiceTypes`);
    },
    getPersonalBloodGroups: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getPersonalBloodGroups`);
    },
    getPersonalEyeColors: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getPersonalEyeColors`);
    },
    getPersonalHairColors: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getPersonalHairColors`);
    },
    getPersonalStatureTypes: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getPersonalStatureTypes`);
    },
    getPersonStatuses: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMP}/getPersonStatuses`);
    },
  },
};
